import { EqualContentsRow } from "./EqualContentsRow";
import { TickBox } from "./TickBox";
import { Fragment } from "react";
import React from "react";

export const TickBoxAndLabelSectionRenderer = ({ title, data, rows, sectionStyle, titleStyle, titlePostComp }) => {
  let titleInlineStyle = { fontWeight: 600, flexGrow: 2, fontSize: "20px", padding: "8px" };
  let secondTitleInlineStyle = { fontWeight: 600, fontSize: "20px", minWidth: "400px" };
  titleStyle && (titleInlineStyle = { ...titleInlineStyle, ...titleStyle });
  return (
    <span style={sectionStyle}>
      {title && (
        <span style={titleInlineStyle}>
          <span style={{ paddingRight: "10px" }}>{title}</span>
          {titlePostComp}
        </span>
      )}

      {rows &&
        rows.map((options) => {
          return (
            <EqualContentsRow>
              {options.map((val) => {
                const isOther = val.title.toLowerCase() === "other" || val.forceOther;
                const tickBoxCheck =
                  typeof data[val.id] === "boolean"
                    ? data[val.id]
                    : (data[val.id] && data[val.id].toLowerCase()) === (val.title && val.title.toLowerCase());
                const tickBindingCheck = val.tickBoxBindingId ? data[val.tickBoxBindingId] : true;
                return val.isTitle ? (
                  <span style={{ ...secondTitleInlineStyle, ...val.titleStyle }}>
                    <span style={{ paddingRight: "10px" }}>{val.title}</span>
                    {val.titlePostComp}
                  </span>
                ) : val.title === "" ? (
                  <div></div>
                ) : val.tickBox ? (
                  <TickBox
                    flag={tickBoxCheck}
                    label={val.title}
                    otherVal={data[val.otherValId] ? `${data[val.otherValId]}${val.otherPostText ? val.otherPostText : ""}` : null}
                    valAreaPostText={isOther && val.otherPostComp ? val.otherPostComp : ""}
                    style={val.valueStyle}
                    forceOther={val.forceOther}
                  />
                ) : (
                  <Fragment>
                    <label className="title" style={val.titleStyle}>{`${val.title}:`}</label>
                    <span
                      style={{
                        minWidth: "190px",
                        borderBottom: "2px solid",
                        paddingLeft: "10px",
                        marginRight: "30px",
                        ...val.valueStyle,
                      }}
                    >
                      {tickBindingCheck && data[val.id]}
                    </span>
                  </Fragment>
                );
              })}
            </EqualContentsRow>
          );
        })}
    </span>
  );
};



// WEBPACK FOOTER //
// ./src/libraries/ReportGenerator/TickBoxAndLabelSectionRenderer.jsx